// Lets a page detach the shell chrome from the URL.
//
// The sidebar and the breadcrumb are both pure functions of the pathname, which
// is right for every address that resolves to a page and wrong for the one that
// doesn't: /sessions/test highlighted "Live sessions" and rendered
// "Dashboard / Live sessions / test" over a page that was reporting it did not
// exist. A page mounts `useShellPathname` to tell the shell to reflect a
// different path than the browser's for as long as it is on screen.
//
// The alternative — teaching SiteHeader which routes are real — was rejected:
// apps/web renders the same component, and it has its own route table.

import { createContext, useContext, useLayoutEffect } from "react";

/** Set by `Layout`. `null` restores the real location. */
export const ShellPathnameContext = createContext<
	((pathname: string | null) => void) | null
>(null);

export function useShellPathname(pathname: string): void {
	const setPathname = useContext(ShellPathnameContext);
	// Layout effect, not effect: the override has to be in place before the
	// browser paints, or the operator sees one frame of the chrome we are
	// here to suppress.
	useLayoutEffect(() => {
		setPathname?.(pathname);
		return () => setPathname?.(null);
	}, [setPathname, pathname]);
}
